import CryptoJS from 'crypto-js';

export function encrypt(key: string, iv: string, needJm: string): string {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const ivHex = CryptoJS.enc.Utf8.parse(iv);
  // CFB 模式，NoPadding
  const encrypted = CryptoJS.AES.encrypt(needJm, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding
  });
  return encrypted.toString();
}